import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LawnCarePage = lazy(() => import('../pages/lawn-care/page'));
const FertilizationPage = lazy(() => import('../pages/fertilization/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/lawn-care',
    element: <LawnCarePage />,
  },
  {
    path: '/fertilization',
    element: <FertilizationPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
